// removed by extract-text-webpack-plugin
module.exports = {"container":"yHLmaK_6yOVYgogpKgSFf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contentContainer/contentContainerComponent.scss
// module id = 676
// module chunks = 22